exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-PaperTrading-___style__wrapper___3FwhL{display:flex;align-items:flex-start;justify-content:space-between}.src-components-PaperTrading-___style__main___3DemH{width:100%}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-PaperTrading-___style__wrapper___3FwhL",
	"main": "src-components-PaperTrading-___style__main___3DemH"
};